import React from "react";

// Header showing name of bot
export default function Header() {
  return <div className="header">&nbsp;Kudu Bot</div>;
}
